import { useRouteLoaderData } from "~/hooks/useRouteLoaderData";

/**
 * Return the site most appropriate for the user.
 */
export function useLocalSite() {
  const { localSite } = useRouteLoaderData("routes/$site");
  return localSite;
}
